var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 5.16789C19 11.0026 10.1964 15.7254 9.82147 15.9204C9.72266 15.9727 9.6122 16 9.5 16C9.38779 16 9.27734 15.9727 9.17853 15.9204C8.80362 15.7254 0 11.0026 0 5.16789C0.00157152 3.79775 0.55614 2.48418 1.54204 1.51534C2.52794 0.546512 3.86466 0.00154431 5.25893 0C7.01049 0 8.54406 0.740174 9.5 1.9913C10.4559 0.740174 11.9895 0 13.7411 0C15.1353 0.00154431 16.4721 0.546512 17.458 1.51534C18.4439 2.48418 18.9984 3.79775 19 5.16789Z",
    fill: "#756E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/like_icon.9142205d4c637988816e536d4c7561b2.svg";
export { ForwardRef as ReactComponent };